<template>
  <div class="search-content">
      <router-view />
  </div>
</template>

<script>
  export default {
    name: 'SettingLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '赛区管理'
            },
//            {
//              key: '2',
//              title: '赛季管理'
//            }, 
            // {
            //   key: '3',
            //   title: '项目配置'
            // },
            // {
            //   key: '4',
            //   title: '项目音乐'
            // },
            // {
            //   key: '5',
            //   title: '话题管理'
            // },
            // {
            //   key: '6',
            //   title: '裁判库'
            // },
            {
              key: '7',
              title: '酒店管理'
            }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/sai/SaiquList':
                return '1'
//              case '/sai/SaijiList':
              case '/sai/SaiquApplyList':
                return '2'
              case '/sai/SubjecttypeList':
                return '3'
              case '/sai/SubjectmusicList':
                return '4'
              case '/sai/TopicList':
                return '5'
              case '/sai/MemberCaipanList':
                return '6'
              case '/sai/SaiquHotelList':
                return '7'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/sai/SaiquList')
                break
              case '2':
                this.$router.push('/sai/SaiquApplyList')
//                this.$router.push('/sai/SaijiList')
                break
              case '3':
                this.$router.push('/sai/SubjecttypeList')
                break
              case '4':
                this.$router.push('/sai/SubjectmusicList')
                break
              case '5':
                this.$router.push('/sai/TopicList')
                break
              case '6':
                this.$router.push('/sai/MemberCaipanList')
                break
              case '7':
                this.$router.push('/sai/SaiquHotelList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
